import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagCA(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAkUExURf39/f8PD/Py8v8ZGf8FBf8hIf8pKfj4+P8vL/uJif1gYPq8vM2CApsAAAIqSURBVDjL1ZA/b9QwGMa9tAG6nGUvHc+qFLGdsTJ0a6R8gBNRbmE5CSU6OqU+IXN0QQgCYusfqTp1o4iqYmOgEp+O57UTSI4KMbDw2I59z/t7H1vH3ndifd3r3FfsnwALryHQNE0LVFXVeA2AbXQ0DWpztmhVDYGGyrDnlBA0BMhZ+IQ/ANXfAbOymkHlJhDMGYCixAkr6mt7VlVklnNWkgosaqwxI/pulUWB1nI2ZQUJRBFad1DHtkUtIIppuIIg+HUdvYhdVDv3vGjVJpBcXbvIfbtFnRJ+B6LIRQ9uP19/R32QkGP4K9D/8rD5cFgjC0Dix4QlSV4kJAfdB/jM0RvyPEclTybM5InJc2Ny+NExgCdELuERYqaMyjglxu04awE8su7YLZPQSAmd3OrL2cVbY96dXd4gAUqw+oB9muxfmfwmMY8DYDYAd9Udr+8GVpo2jbHfB7QRRuAj3EpwSGAAEFp7e8RworLAFSfYqM4v3FJTEmoTJrjWmJpbu+JBu9YeeVILJGjhxbWL1UkATuP4CC2+MmJcc5qCK2sfrtdyd73GHzYmBzYHwFtExbFT6s1rFeM0pqcQ44EgZRXmp4+WNO7cHhDjjlidnyqKuAuAj4Tzr9aqYUIq6SC5Qj2OcQ9pLKXkKZdyxLB70RWh6B+ZcnRKSkCAlBmm6mtPZplM0yw9YBlECZtAqwPmiyn4X1W8dg+Gbw0JGf0cJqTk4fMTyDaAzv0/gB8wXU1Tj2nJ4wAAAABJRU5ErkJggg==",
    alt: "CA"
  }, props));
}